import * as configuracaoNegocios from '../../../api/configuracao_negocios'

const state = {
  list: []
}

const mutations = {
}

const actions = {
  async getPorNome ({ commit }, payload) {
    let retorno = await configuracaoNegocios.getPorNome(payload)
    return retorno.instancia
  },
  async getPorNomeCache ({ commit }, payload) {
    let retorno = await configuracaoNegocios.getPorNomeCache(payload)
    return retorno.instancia
  },
  async edit ({ commit }, payload) {
    let retorno = await configuracaoNegocios.edit(payload)
    return retorno.instancia
  },
  async alterarConfiguracao ({ commit }, payload) {
    let retorno = await configuracaoNegocios.alterarConfiguracao(payload)
    return retorno.instancia
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/gerenciador/configuracaoNegocios.js